import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { InsuranceDashboard } from "./newComponents/InsuranceNew/InsuranceDashboard";

import ROLES from "constants/roles";

import NoPermission from "pages/account/NoPermission";
import { isUserAuthenticated, getLoggedInUser } from "./helpers/authUtils";
import AssistanceReceived from "./pages/modules/assistance/assistance_in/AssistanceReceived";
import AssistanceReceivedNew from "./pages/modules/assistance/assistance_in/AssistanceReceivedNew";
import AssistanceReceivedView from "./pages/modules/assistance/assistance_in/AssistanceReceivedView";
import AssistanceOut from "./pages/modules/assistance/assistance_out/AssistanceOut";
import AssistanceOutNew from "./pages/modules/assistance/assistance_out/AssistanceOutNew";
import AssistanceOutView from "./pages/modules/assistance/assistance_out/AssistanceOutView";
import Modules from "./pages/modules/Modules";
import Assistance from "./pages/modules/assistance/Assistance";
import AssistanceNew from "./pages/modules/assistance/AssistanceNew";
import AssistanceList from "./pages/modules/assistance/AssistanceList";
import AssistanceCreate from "./pages/modules/assistance/AssistanceCreate";
import Budget from "./pages/modules/budget/Budget";
import BudgetAccountAdd from "./pages/modules/budget/BudgetAccountAdd";
import BudgetAccountList from "./pages/modules/budget/BudgetAccountList";
import BudgetCreate from "./pages/modules/budget/BudgetCreate";

import DebtCreate from "./pages/planner/debt/operations/DebtCreate";
import SocialSecurityCreate from "./pages/planner/social_security/SocialSecurityCreate";
import SocialSecurityDashboard from "./pages/planner/social_security/SocialSecurityDashboard";

import TestForm from "./pages/TestForm";
import ClientsPlans from "./pages/client_info/clients_plans/ClientsPlans";
import MyInformation from "./pages/client_info/clients_plans/MyInformation";
import EditInformation from "./pages/client_info/clients_plans/EditInformation";
import ComparePlans from "./pages/client_info/clients_plans/ComparePlans"; //new
import ClientDetail from "./pages/client_info/clients_plans/ClientDetail"; //new
import ClientEditDetail from "./pages/client_info/clients_plans/ClientEditDetail"; //new
import ClientNew from "./pages/client_info/clients_plans/ClientNew";
import ClientPlanNew from "./pages/client_info/clients_plans/ClientPlanNew";
import ClientInfo from "./pages/client_info/ClientInfo";
import TaxInflation from "./pages/client_info/tax_inflation/TaxInflation";
import TaxInflationNew from "./pages/client_info/tax_inflation/TaxInflationNew";
// import ClientContacts from './pages/client_info/client_contacts/ClientContacts';
import ClientContactNew from "./pages/client_info/client_contacts/ClientContactNew";
import ClientContactView from "./pages/client_info/client_contacts/ClientContactView";
import Reports from "./pages/reports";
import ReportAsset from "./pages/reports/ReportAsset";
import AddAsset from "./pages/reports/AddAsset";
import ReturnRates from "./pages/client_info/return_rates/ReturnRates";
import ReturnRatesNew from "./pages/client_info/return_rates/ReturnRatesNew";
import Assets from "./pages/modules/assets/Assets";
import AssetAllocation from "./pages/modules/assests_new/assetAllocation";
import LiabilitiesCredit from "./pages/modules/liabilities_credit/LiabilitiesCredit";
import LiabilityCreditNew from "./pages/modules/liabilities_credit/LiabilityCreditNew";
import LiabilityCreditView from "./pages/modules/liabilities_credit/LiabilityCreditView";
import SocialSecurityModule from "./pages/modules/social_security/SocialSecurityModule";
import SocialSecurityNew from "./pages/modules/social_security/SocialSecurityNew";
import Income from "./pages/modules/income/Income";
import IncomeNew from "./pages/modules/income/IncomeNew";
import IncomeView from "./pages/modules/income/IncomeView";
import Insurance from "./pages/modules/insurance/Insurance";
import InsuranceNew from "./pages/modules/insurance/InsuranceNew";
import InsuranceView from "./pages/modules/insurance/InsuranceView";
import InsuranceAllocation from "./pages/modules/insurance/subforms/insuranceAllocation";
import InsuranceSubForm from "./pages/modules/insurance/subforms/insuranceSubForm";
// Reports
import AllInsuranceProducts from "./pages/reports/AllInsuranceProducts";
import PrefessionalTeam from "./pages/reports/PrefessionalTeam";
import SocialSecurity from "./pages/reports/SocialSecurity";
import GeneralInformation from "./pages/reports/GeneralInformation";
import IncomeReport from "./pages/reports/IncomeReport";
import GoalsReport from "./pages/reports/GoalsReport";
import InsuranceReport from "./pages/reports/InsuranceReport";
import LiabilitiesCreditReport from "./pages/reports/LiabilitiesCreditReport";
import LiquidityReport from "./pages/reports/LiquidityReport";
import MonthlySavings from "./pages/reports/MonthlySavings";
import StartingBusinessReport from "./pages/reports/StartingBusinessReport";
import AssetsItemReport from "./pages/reports/AllItemsReport/Assets";
import IncomeAndTaxes from "./pages/reports/AllItemsReport/IncomeAndTaxes";
import InsurancePayout from "./pages/reports/AllItemsReport/InsurancePayout";
import BudgetAndGoals from "./pages/reports/AllItemsReport/BudgetAndGoals";
import Liabilities from "./pages/reports/AllItemsReport/Liabilities";
import BudgetReport from "./pages/reports/BudgetReport";
import BudgetDetailed from "./pages/reports/BudgetDetailed";
import NetWorthReport from "./pages/reports/NetWorthReport";
import Charts from "./pages/charts";
import AssetsNew from "./pages/modules/assets/AssetsNew";
import AssetsView from "./pages/modules/assets/AssetsView";
import Schedules from "./pages/schedules/Schedules";
import AssetDistribution from "./pages/schedules/AssetDistribution";
import AssetDistributionRMD from "./pages/schedules/AssetDistributionRMD";
import AmortizationReport from "./pages/schedules/AmortizationReport";
import AmortizationSchedule from "./pages/schedules/AmortizationSchedule";
import DebtPayoffAmount from "./pages/schedules/DebtPayoffAmount";
import PayoffDebtFreeDate from "./pages/schedules/PayoffDebtFreeDate";
import PortfolioPerformance from "./pages/schedules/PortfolioPerformance";

//goals
import Goals from "./pages/goals/Goals";
import GoalsNew from "./pages/goals/GoalsNew";
import GoalsList from "./pages/goals/GoalsList";

// Worst Case Scenarios
import WorstCaseScenarios from "./pages/worst_case_scenarios";
import ExecutorTrusteeStart from "./pages/worst_case_scenarios/ExecutorTrusteeStart";
import AudioVideoMessage from "./pages/worst_case_scenarios/AudioVideoMessage";
import AddAudioVideoMessage from "./pages/worst_case_scenarios/AudioVideoMessage/Add";
import CheckList from "./pages/worst_case_scenarios/CheckList";
import AddCheckList from "./pages/worst_case_scenarios/CheckList/Add";
import ContactList from "./pages/worst_case_scenarios/ContactList";
import AddContactList from "./pages/worst_case_scenarios/ContactList/Add";
import ImportantDocuments from "./pages/worst_case_scenarios/ImportantDocuments";
import AddImportantDocuments from "./pages/worst_case_scenarios/ImportantDocuments/Add";
import PersonalInstructions from "./pages/worst_case_scenarios/PersonalInstructions";
import AddPersonalInstructions from "./pages/worst_case_scenarios/PersonalInstructions/Add";
import ListOfLargeBills from "./pages/worst_case_scenarios/ListOfLargeBills";
import AddListOfLargeBill from "./pages/worst_case_scenarios/ListOfLargeBills/Add";
import LitigationLists from "./pages/worst_case_scenarios/LitigationLists";
import AddLitigationList from "./pages/worst_case_scenarios/LitigationLists/Add";
import LocationOfPersonalItems from "./pages/worst_case_scenarios/LocationOfPersonalItems";
import AddLocationOfPersonalItem from "./pages/worst_case_scenarios/LocationOfPersonalItems/Add";
import ListOfPasswords from "./pages/worst_case_scenarios/ListOfPasswords";
import AddListOfPasswords from "./pages/worst_case_scenarios/ListOfPasswords/Add";
import PrepaidBurialExpenses from "./pages/worst_case_scenarios/PrepaidBurialExpenses";
import AddPrepaidBurialExpenses from "./pages/worst_case_scenarios/PrepaidBurialExpenses/Add";
import ProgressStatuses from "./pages/worst_case_scenarios/ProgressStatuses";
import AddProgressStatuses from "./pages/worst_case_scenarios/ProgressStatuses/Add";
import EmailsToSend from "./pages/worst_case_scenarios/EmailsToSend";
import AddEmailsToSend from "./pages/worst_case_scenarios/EmailsToSend/Add";

// Worst Case Scenarios
import WorstCaseScenariosView from "./pages/worst_case_scenarios/view";
import AudioVideoMessageView from "./pages/worst_case_scenarios/view/AudioVideoMessage";
import CheckListView from "./pages/worst_case_scenarios/view/CheckList";
import ContactListView from "./pages/worst_case_scenarios/view/ContactList";
import ImportantDocumentsView from "./pages/worst_case_scenarios/view/ImportantDocuments";
import PersonalInstructionsView from "./pages/worst_case_scenarios/view/PersonalInstructions";
import ListOfLargeBillsView from "./pages/worst_case_scenarios/view/ListOfLargeBills";
import LitigationListsView from "./pages/worst_case_scenarios/view/LitigationLists";
import LocationOfPersonalItemsView from "./pages/worst_case_scenarios/view/LocationOfPersonalItems";
import ListOfPasswordsView from "./pages/worst_case_scenarios/view/ListOfPasswords";
import PrepaidBurialExpensesView from "./pages/worst_case_scenarios/view/PrepaidBurialExpenses";
import ProgressStatusesView from "./pages/worst_case_scenarios/view/ProgressStatuses";
import EmailsToSendView from "./pages/worst_case_scenarios/view/EmailsToSend";
import Summary from "./pages/worst_case_scenarios/view/Summary";
import AssetPlanetMessage from "./pages/worst_case_scenarios/view/AssetPlanetMessage";
import DelegateAccess from "./pages/auth/DelegateAccess";
import OtpValidate from "./pages/auth/OtpValidate";
import TrusteeLogin from "./pages/auth/TrusteeLogin";
import Welcome from "pages/Welcome";

import Planner from "pages/planner/planner";

import Inventory from "./components/form/inventory/inventory";
import Collection from "./components/form/inventory/collection";

//Protector
import Protector from "pages/protector/protector";
import Death from "./pages/protector/death/Death";
import DeathCreate from "./pages/protector/death/operations/DeathCreate";
import Disaster from "./pages/protector/disaster/Disaster";
import DisasterCreate from "./pages/protector/disaster/operations/DisasterCreate";
import Divorce from "./pages/protector/divorce/Divorce";
import DivorceCreate from "./pages/protector/divorce/operations/DivorceCreate";
import Disability from "./pages/protector/disability/Disability";
import DisabilityCreate from "./pages/protector/disability/operations/DisabilityCreate";
import { AcceptInvitation } from "./pages/auth/AcceptInvitation";
////////////////   Building New Goal Modules - will be re-arranged later
import TestMods from "pages/testMods/contributions_savings/friendsFamily";
import OneTimePayments from "pages/testMods/contributions_savings/oneTimePayments";
import MultiplePayments from "pages/testMods/contributions_savings/multiplePayments";
import QuestionAddAnotherSubForm from "pages/testMods/contributions_savings/questionLoopAdd";
import AssignSavingsToGoalSubForm from "pages/testMods/AssignAssets/assignSavingsToGoal";
import QuestionAddAnotherContSavings from "pages/testMods/AssignAssets/questionLoopAdd";
import StudentLoanDetails from "pages/testMods/StudentLoan/studentLoanDetails";
import QuestionAddAnotherStudentLoan from "pages/testMods/StudentLoan/questionLoopAdd";
import ScholarshipsGrantsDetails from "pages/testMods/Scholarships_Grants/schlolarships_grants";
import QuestionAddAnotherScholarshipGrant from "pages/testMods/Scholarships_Grants/questionLoopAdd";
import PersonalLoanHeloc from "pages/testMods/personal_loan_heloc/loan_details";
import QuestionAddAnotherPersonalLoan from "pages/testMods/personal_loan_heloc/questionLoopAdd";
import ParentPLUSLoan from "pages/testMods/personal_loan_heloc/parent_plus_loan";
import PersonalLoanHelocDetails from "pages/testMods/personal_loan_heloc/personal_loan_heloc";
import WorkStudyDetails from "pages/testMods/workStudy/workStudy";
import QuestionAddAnotherWorkStudy from "pages/testMods/workStudy/questionLoopAdd";
import PrivateEducationDetails from "pages/testMods/privateEducationDetails/privateEducationDetails";
import PrivateEducationK12Details from "pages/testMods/privateEducationDetails/privateEducationK12";
import RoomBoardMiscDetails from "pages/testMods/privateEducationDetails/room_board_misc";
import TuitionCosts from "pages/testMods/tuitionCosts/tuitionCosts";
///////////////
import PageNotFound from "./pages/auth/PageNotFound";
import DemoComponent from "./components/demo-component/demo-components";
///////////// PRIVATE EDUCATION
import PrivateEducationList from "pages/testMods/PrivateEducation.js";
import PrivateEducationDash from "pages/testMods/PrivateEducationDash.js";
import PrivateEducationNew from "pages/testMods/PrivateEducationNew.js";

import ClientContacts from "./components/client-information/client-contacts/client-contacts";
import CustomComponents from "./components/client-information/client-contacts/sub-components/custom-components";
import TaxInflationMain from "./components/client-information/tax-and-inflation/sub-components/tax-inflation-main";
import TaxAndInflation from "./components/client-information/tax-and-inflation/tax-and-inflation";
import RatesOfReturn from "./components/client-information/rates-of-return/rates-of-return";
import RatesOfReturnMain from "./components/client-information/rates-of-return/sub-components/rates-of-return-main";
import NewForm from "./pages/modules/assets/subforms/newForm";
import Collectibles from "./components/organizer/assets/collectibles/collectibles";
import inventory from "./components/organizer/assets/inventory/inventory";
import propertyAdd from "./components/organizer/assets/inventory/property/property-add";
import Items from "./components/organizer/assets/collectibles/items/items";
import Faq from "./components/faq/faq";
import itemAdd from "./components/organizer/assets/inventory/Item/item-add";
import ItemMain from "./components/organizer/assets/inventory/Item/item-main";
import ItemUpdate from "./components/organizer/assets/inventory/Item/item-update";
import Detail from "./components/organizer/assets/inventory/detail";
// new components
import AllocationSubform from "./pages/modules/assests_new/subForms/allocationSubForm";
import Signup from "./pages/auth/Signup";
import SignupV2 from "./pages/auth/SignupV2";
import AssetListing from "./pages/modules/assests_new/asset-listing/Asset-Listing";
// new stepper for death components
import demoStepper from "./newComponents/demoStepper";
import { SecureLinks } from "./pages/auth/SecureLinks";
import { DeathDashboard } from "./newComponents/DeathDashboard/DeathDashboard";
import IncomeAllocation from "./pages/modules/income/subforms/incomeAllocation";
import IncomeSubForm from "./pages/modules/income/subforms/incomeSubForm";
import AssetAllocationLiabilites from "./pages/modules/liabilities_credit/subforms/assetAllocation";
import LiabilitySubForm from "./pages/modules/liabilities_credit/subforms/liabilitySubForm";
import LiabilityListing from "./pages/modules/liabilities_credit/subforms/Liability-Listing";
import { DebtPayOffDashboard } from "./components/form/debtPayOff/DebtPayOffDashboard";
import { DebtDetails } from "./components/form/debtPayOff/DebtDetails";
import { Strategy } from "./components/form/debtPayOff/Strategy";
import { PayOffPlans } from "./components/form/debtPayOff/PayOffPlans";
import { ThirdPartyResource } from "./newComponents/ThirdPartyResource/ThirdPartyResource";
import { ProfilePage } from "./newComponents/ProfilePage/ProfilePage";
import { MainDashboard } from "./newComponents/MainDashboard/MainDashboard";
import { SwtichDashboardMain } from "./newComponents/MainDashboard/SwtichDashboardMain";
import { LiabilityDashboard } from "./newComponents/LiabilityNew/LiabilityDashboard";
import { IncomeDashboard } from "./newComponents/IncomeNew/IncomeDashboard";
import { AssetsDashboard } from "./newComponents/AssetsNew/AssetsDashboard";
import { RoleMain } from "./newComponents/Settings/Roles/RoleMain";
import { SettingDashboard } from "./newComponents/Settings/SettingDashboard";
import PlaidMainNew from "./newComponents/Plaid/PlaidMainNew";
import CheckoutForm from "./newComponents/StripePayment/CheckoutForm";
import { PaymentMain } from "./newComponents/StripePayment/PaymentMain";
import { Subscription } from "./newComponents/SubScriptions/Subscription";
import { ForgetPassword } from "./pages/auth/ForgetPassword";
import { Feedback } from "./newComponents/Feedback/Feedback";
import { ClientPlan } from "./newComponents/ClientsPlan/ClientPlan";
import { BudgetMain } from "./newComponents/Budget/BudgetMain";
import { AddBudget } from "./newComponents/Budget/BudgetComponents/AddBudget/AddBudget";
import { AddTransaction } from "./newComponents/Budget/BudgetComponents/AddTransaction/AddTransaction";
import { Recurring } from "./newComponents/Budget/BudgetComponents/Recurring/Recurring";
import { BudgetDetailReports } from "./newComponents/BudgetDetailReports/BudgetDetailReports";
import { AllReportsMain } from "./newComponents/BudgetDetailReports/ReportComponents/AllReportsMain";
import { BudgetReportDashboard } from "./newComponents/BudgetDetailReports/BudgetReportDashboard";
import { Rewards } from "./newComponents/Rewards/Rewards";
import { SelectGoal } from "./newComponents/Goals/GoalSelection/SelectGoal";
import { GoalsDashboard } from "./newComponents/Goals/GoalsDashboard/GoalsDashboard";
import GoalAllocationSubform from "./newComponents/Goals/GoalForms/GoalAllocationSubform";
import { FreeTrailPage } from "./newComponents/StripePayment/FreeTrailPage";
import NewDashboardRoutePage from "./components/newly-components/NewDashboardRoutePage";
import Oauth from "./newComponents/MainDashboard/Oauth";
import { ImportantDocumentMain } from "./newComponents/ImportantDocument/ImportantDocumentMain";
import { ModuleDocuments } from "./newComponents/ImportantDocument/ModuleDocuments/ModuleDocuments";
import { ChatSystemMain } from "./newComponents/ChatSystem/ChatSystemMain";
import InsuranceAllocationSubform from "./newComponents/V2Insurance/InsuranceAllocationSubform";
import InsuranceSelection from "./newComponents/V2Insurance/InsuranceSelection";
import { InsuranceMainDashboard } from "./newComponents/V2Insurance/InsuranceMainDashboard";
import { QuestionerMain } from "./newComponents/Questioner/QuestionerMain";
import { RecurringPattren } from "./newComponents/Budget/BudgetComponents/RecurringPattren/RecurringPattren";
import DisabilityStepper from "./newComponents/DisabilityStepper";
import DisasterStepper from "./newComponents/DisasterStepper";
import DivorceStepper from "./newComponents/DivorceStepper";
import { TransactionRules } from "./newComponents/Budget/BudgetComponents/TransactionRules/TransactionRules";
import { DisabilityDashboard } from "./pages/protector/disability/DisabilityDashboard/DisabilityDashboard";
import { DisasterDashboard } from "./pages/protector/disaster/DisasterDashboard/DisasterDashboard";
import { DivorceDashboard } from "./pages/protector/divorce/DivorceDashboard/DivorceDashboard";
import { ProfilePageV2 } from "./newComponents/ProfilePageV2/ProfilePageV2";
import LoginV2 from "./pages/auth/LoginV2";
import OTPValidateV2 from "./pages/auth/OTPValidateV2";
import ProfessionalViewDashboard from "./newComponents/ProfessionalView/ProfessionalViewDashboard/ProfessionalViewDashboard";
import { PaymentV2 } from "./newComponents/StripePayment/PaymentV2";
import { DebtDashboardMain } from "./newComponents/DebtDashboardV2/DebtDashboardMain";
import { DebtStrategy } from "./newComponents/DebtDashboardV2/strategy/DebtStrategy";
import { DebtsDetails } from "./newComponents/DebtDashboardV2/DebtDetails/DebtsDetails";
import { SocialSecurityMain } from "./newComponents/SocialSecurity/SocialSecurityMain";
import { SocialSecurityFRA } from "./newComponents/SocialSecurity/components/SocialSecurityFRA";
import { SocialSecurityEarly70 } from "./newComponents/SocialSecurity/components/SocialSecurityEarly70";
import { SocialSecurityEarlyvsFRA } from "./newComponents/SocialSecurity/components/SocialSecurityEarlyvsFRA";
import { CompareTwoAges } from "./newComponents/SocialSecurity/components/CompareTwoAges";
import { ManageOwner } from "./newComponents/ManageOwners/ManageOwner";

// lazy load all the views
const Dashboard = React.lazy(() => import("./pages/Dashboard"));

// auth
const Login = React.lazy(() => import("./pages/auth/Login"));
const Logout = React.lazy(() => import("./pages/auth/Logout"));
// const ForgetPassword = React.lazy(() =>
//   import("./pages/account/ForgetPassword")
// );
const Register = React.lazy(() => import("./pages/account/Register"));
const ConfirmAccount = React.lazy(() => import("./pages/account/Confirm"));

// handle auth and authorization
// const PrivateRoute = ({ component: Component,disableRoles, ...rest }) =>{
//   const history = useHistory()
//   const token = localStorage.getItem("userLoginToken")
// console.log(history.location.pathname);

//   return (
//   <Route {...rest} render={props => {
//     if (!token) {

//       // not logged in so redirect to login page with the return url
//       return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
//     }
// if(token && rest.path == '/login'){
//   history.push('./dashboard')
// }
//     // check if route is restricted by role
//     // const loggedInUser = getLoggedInUser();
//     // if (disableRoles && disableRoles.indexOf(loggedInUser.role) != -1) {
//     //   // role not authorised so redirect to home page
//     //   return <Redirect to={{ pathname: '/nopermission' }} />
//     // }
//     // authorised so return component

//     return <Component {...props} />
//   }} />
// )
// }

// const PublicRoute = ({ component: Component, disableRoles, ...rest }) => {
// const history = useHistory
// const token = localStorage.getItem("userLoginToken")

//   return(
//     <Route {...rest} render={props => {
//       if(token && rest.path == '/login'){
//         history.push('./dashboard')
//       }
//       return <Component {...props} />
//     }} />
//   )
// }

const PrivateRoute = ({ component: Component, disableRoles, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      // const isAuthTokenValid = isUserAuthenticated();
      const token = localStorage.getItem("userLoginToken");
      // alert(props.location.pathname.startsWith("/acceptInvitation"))
      if (
        token &&
        props.location &&
        props.location.pathname &&
        props.location.pathname.startsWith("/acceptInvitation")
      ) {
        console.log("here in routes if login");
        if (props.location.PathExact !== "PathExact") {
          console.log("props.location return otp", props.location);
          localStorage.removeItem("userLoginToken");
        }
        console.log("new location", props.location);

        if (props.location && props.location.pathname && props.location.PathExact !== "PathExact") {
          console.log("here in acctecpt invite 1");
          return (
            <Redirect
              to={{
                pathname:
                  props.location &&
                  props.location.pathname &&
                  props.location.pathname.startsWith("/acceptInvitation")
                    ? "/trusteeLogin"
                    : "/login",
                state: { from: props.location },
                PathExact: "PathExact",
              }}
            />
          );
        }
        if (props.location && props.location.pathname && props.location.PathExact === "PathExact") {
          console.log("here in acctecpt invite 2", props.location.state.from.pathname);
          return <Component {...props} />;
        }
      }
      // else if (
      //   token &&
      //   props.location &&
      //   props.location.pathname &&
      //   props.location.pathname.startsWith("/payment")
      // ) {
      //   console.log("here in routes if login plaid",props.location);
      //   if (props.location.PathExact !== "PathExact") {
      //     console.log("props.location return otp plaid", props.location);
      //     localStorage.removeItem("userLoginToken");
      //   }
      //   console.log("new location", props.location);

      //   if (
      //     props.location &&
      //     props.location.pathname &&
      //     props.location.PathExact !== "PathExact"
      //   ) {
      //     console.log("here in accept package 1");
      //     return (
      //       <Redirect
      //         to={{
      //           pathname:
      //             props.location &&
      //             props.location.pathname &&
      //             props.location.pathname.startsWith("/payment")
      //               ? "/login"
      //               : "/payment",
      //           state: { from: props.location },
      //           PathExact: "PathExact",
      //         }}
      //       />
      //     );
      //   }
      //   if (
      //     props.location &&
      //     props.location.pathname &&
      //     props.location.PathExact === "PathExact"
      //   ) {
      //     console.log(
      //       "here in pathname invite 2",
      //       props.location.state.from.pathname
      //     );
      //     return <Component {...props} />;
      //   }
      // }

      // without logout is this
      else if (
        token &&
        props.location &&
        props.location.pathname &&
        props.location.pathname.startsWith("/payment")
      ) {
        console.log("new location", props.location);

        if (
          props.location &&
          props.location.pathname &&
          props.location.PathExact &&
          props.location.PathExact !== "PathExact"
        ) {
          console.log("here in accept package 1");
          return (
            <Redirect
              to={{
                pathname:
                  props.location && props.location.pathname && props.location.pathname.startsWith("/payment")
                    ? "/login"
                    : "/payment",
                state: { from: props.location },
                PathExact: "PathExact",
              }}
            />
          );
        }
        if (props.location && props.location.pathname && props.location.PathExact === "PathExact") {
          console.log("here in pathname invite 2", props.location.state.from.pathname);
          return <Component {...props} />;
        }
      }

      if (!token && props.location.pathname.startsWith("/payment")) {
        // not logged in so redirect to login page with the return url
        return (
          <Redirect
            to={{
              pathname:
                props.location && props.location.pathname && props.location.pathname.startsWith("/payment")
                  ? "/login"
                  : "/login",
              state: { from: props.location },
              PathExact: "PathExact",
            }}
          />
        );
      }

      if (!token && props.location.pathname.startsWith("/acceptInvitation")) {
        console.log("fhjkljhgf1", props.location.pathname.startsWith("/payment"));
        // not logged in so redirect to login page with the return url
        return (
          <Redirect
            to={{
              pathname:
                props.location &&
                props.location.pathname &&
                props.location.pathname.startsWith("/acceptInvitation")
                  ? "/trusteeLogin"
                  : "/login",
              state: { from: props.location },
              PathExact: "PathExact",
            }}
          />
        );
      }
      if (!token) {
        // not logged in so redirect to login page with the return url
        return (
          <Redirect
            to={{
              pathname:
                props.location &&
                props.location.pathname &&
                props.location.pathname.startsWith("/acceptInvitation")
                  ? "/trusteeLogin"
                  : "/login",
              state: { from: props.location },
              PathExact: "PathExact",
            }}
          />
        );
      }

      // check if route is restricted by role
      const loggedInUser = getLoggedInUser();
      const inactiveRoles = ["inActive financial adviser client", "inActive Financial Advisor", "inactiveClient"]
      const userRole =
        localStorage.getItem("role") != "undefined" && JSON.parse(localStorage.getItem("role") || null);
      if (inactiveRoles.includes(userRole)) {
        return (
          <Redirect
            to={{
              pathname: "/payment",
              state: { from: props.location },
              PathExact: "PathExact",
            }}
          />
        );
      } else {
        return <Component {...props} />;
      }
      // if (disableRoles && disableRoles.indexOf(loggedInUser.role) != -1) {
      //   // role not authorised so redirect to home page
      //   return <Redirect to={{ pathname: '/nopermission' }} />
      // }
      // authorised so return component

      // return <Component {...props} />;
    }}
  />
);

const PublicRoute = ({ component: Component, disableRoles, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return <Component {...props} />;
    }}
  />
);

const routes = [
  // auth and account
  { 
    path: "/login",
    name: "Login",
    // component: Login,  // for live right now
    component: LoginV2, // for stage v2
    route: PublicRoute
  },
  // { path: "/sign-up", name: "SignUp", component: Signup, route: PublicRoute },
  // //sign up
  {
    path: "/sign-up",
    name: "Signup",
    // component: Signup, // for live right now
    component:SignupV2, // for stage v2
    route: PublicRoute,
  },
  {
    path: "/acceptInvitation",
    name: "Accept Invitation",
    component: AcceptInvitation,
    route: PrivateRoute,
  },
  {
    path: "/payment",
    name: "Payment",
    component: PaymentMain,
    route: PrivateRoute,
  },
  {
    path: "/paymentv2",
    name: "Payment",
    component: PaymentV2,
    route: PrivateRoute,
  },
  {
    path: "/free-trial",
    name: "Free Trial",
    component: FreeTrailPage,
    route: PrivateRoute,
  },
  {
    path: "/questioner",
    name: "Profile Questionnaire",
    component: QuestionerMain,
    route: PrivateRoute,
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: Subscription,
    route: PrivateRoute,
  },
  {
    path: "/settings",
    name: "Setting",
    component: SettingDashboard,
    route: PrivateRoute,
  },
  {
    path: "/professional-view",
    name: "Professional View",
    // component: GoalsList, // old component
    component: ProfessionalViewDashboard,
    route: PublicRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Goals List",
  },
  {
    path: "/plaid",
    name: "plaid",
    // component:PlaidTwo,
    component: PlaidMainNew,
    route: PrivateRoute,
  },
  { path: "/logout", name: "Logout", component: Logout, route: Route },
  {
    path: "/forget-password",
    name: "Forget Password",
    component: ForgetPassword,
    // component: ForgetPassword,
    route: PublicRoute,
  },
  {
    path: "/otpvalidation",
    name: "Otp",
    // component: OtpValidate, // for live right now
    component: OTPValidateV2, // for stage v2
    route: PublicRoute,
    // disableRoles: [],
    // title: "Otp",
  },
  {
    path: "/trusteeLogin",
    name: "TrusteeLogin",
    component: TrusteeLogin,
    route: PublicRoute,
    // disableRoles: [],
    // title: "Otp",
  },
  { path: "/register", name: "Register", component: Register, route: Route },
  {
    path: "/confirm",
    name: "Confirm",
    component: ConfirmAccount,
    route: Route,
  },
  {
    path: "/nopermission",
    name: "No Permission",
    component: NoPermission,
    route: Route,
  },

  {
    path: "/test",
    name: "TestForm",
    component: TestForm,
    route: PrivateRoute,
    disableRoles: [],
    title: "Test Form",
  },
  {
    path: "/auth/callback",
    name: "Oauthcallback",
    component: Oauth,
    route: PrivateRoute,
    disableRoles: [],
    title: "Test Form",
  },
  {
    path: "/protector/death",
    name: "DemoDeath",
    component: demoStepper,
    route: PrivateRoute,
    disableRoles: [],
    title: "DemoDeath",
  },
  {
    path: "/protector/disability",
    name: "Disability",
    component: DisabilityStepper,
    route: PrivateRoute,
    disableRoles: [],
    title: "Disability",
  },
  {
    path: "/protector/disability/dashboard",
    name: "Disability",
    component: DisabilityDashboard,
    route: PrivateRoute,
    disableRoles: [],
    title: "Disability",
  },
  {
    path: "/protector/disaster",
    name: "Disaster",
    component: DisasterStepper,
    route: PrivateRoute,
    disableRoles: [],
    title: "Disaster",
  },
  {
    path: "/protector/disaster/dashboard",
    name: "Disaster",
    component: DisasterDashboard,
    route: PrivateRoute,
    disableRoles: [],
    title: "Disaster",
  },
  {
    path: "/protector/divorce",
    name: "Divorce",
    component: DivorceStepper,
    route: PrivateRoute,
    disableRoles: [],
    title: "Divorce",
  },
  {
    path: "/protector/divorce/dashboard",
    name: "Divorce",
    component: DivorceDashboard,
    route: PrivateRoute,
    disableRoles: [],
    title: "Divorce",
  },
  {
    path: "/protector/death/dashboard",
    name: "DeathDashboard",
    component: DeathDashboard,
    route: PrivateRoute,
    disableRoles: [],
    title: "DeathDashboard",
  },
  {
    path: "/secureLink",
    name: "Secure Link",
    component: SecureLinks,
    route: PrivateRoute,
    title: "Secure Link",
  },
  {
    path: "/feedback",
    name: "feedback",
    component: Feedback,
    route: PrivateRoute,
    title: "Feedback",
  },

  // other pages
  {
    path: "/dashboard",
    name: "Dashboard",
    component: SwtichDashboardMain,
    // component: Dashboard,
    route: PrivateRoute,
    disableRoles: [],
    title: "Dashboard",
  },
  {
    path: "/new-dashboard",
    name: "New Dashboard",
    component: MainDashboard,
    // component: Dashboard,
    route: PrivateRoute,
    disableRoles: [],
    title: "Dashboard",
  },
  {
    path: "/select-dashboard",
    name: "Select Dashboard",
    component: NewDashboardRoutePage,
    // component: Dashboard,
    route: PrivateRoute,
    disableRoles: [],
    title: "SelectDashboard",
  },
  // {
  //   path: "/dashboardNew",
  //   name: "DashboardNew",
  //   component: MainDashboard,
  //   route: PrivateRoute,
  //   title: "DashboardNew",
  // },
  {
    path: "/delgateAccess",
    name: "Delegate Access",
    component: DelegateAccess,
    route: PrivateRoute,
    disableRoles: [],
    title: "Delgate",
  },
  {
    path: "/profilePage",
    name: "Profile Page",
    // component: ProfilePage,  //for live right now
    component: ProfilePageV2, // for stage new profile page
    route: PrivateRoute,
    title: "profilePage",
  },
   {
    path: "/manage-owners",
    name: "Manage Owners & Entities",
    component: ManageOwner, // for stage new profile page
    route: PrivateRoute,
    title: "Manage Owners & Entities",
  },
  {
    path: "/rewards",
    name: "Rewards",
    component: Rewards,
    route: PrivateRoute,
    title: "Rewards",
  },
  {
    path: "/thirdPartyResources",
    name: "thirdPartyResources",
    component: ThirdPartyResource,
    route: PrivateRoute,
    title: "thirdPartyResources",
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: Welcome,
    route: PrivateRoute,
    disableRoles: [],
    title: "Welcome",
  },

  //modules
  {
    path: "/organizer",
    name: "Modules",
    component: Modules,
    route: PrivateRoute,
    disableRoles: [],
    title: "Modules",
  },

  {
    path: "/assistance",
    name: "Modules",
    component: AssistanceList,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Assistance",
  },
  //assistance
  // { path: '/assistance_in', name: 'AssistanceReceived', component: AssistanceReceived, route: PrivateRoute, disableRoles: [], title: 'Assistance Received'},
  {
    path: "/assistance_in_new",
    name: "AssistanceReceived New",
    component: AssistanceReceivedNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assistance Received New",
  },
  {
    path: "/assistance_in_edit/:assistanceInID",
    name: "AssistanceReceived Edit",
    component: AssistanceReceivedNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assistance Received New",
  },
  {
    path: "/assistance_in_view/:assistanceInID",
    name: "AssistanceReceived View",
    component: AssistanceReceivedView,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Assistance Received View",
  },
  // { path: '/assistance_out', name: 'Assistance Out', component: AssistanceOut, route: PrivateRoute, disableRoles: [], title: 'Assistance Out' },
  {
    path: "/assistance_out_new",
    name: "Assistance Out New",
    component: AssistanceOutNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assistance Out New",
  },
  {
    path: "/assistance_out_edit/:assistanceOutID",
    name: "Assistance Out Edit",
    component: AssistanceOutNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assistance Out Edit",
  },
  {
    path: "/assistance_out_view/:assistanceOutID",
    name: "Assistance Out View",
    component: AssistanceOutView,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Assistance Out View",
  },
  {
    path: "/assistance_new",
    name: "Assistance New",
    component: Assistance,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assistance New",
  },
  {
    path: "/assistance/create",
    name: "Assistance Create",
    component: AssistanceCreate,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assistance Create",
  },

  {
    path: "/assets",
    name: "Asset",
    component: AssetsDashboard,
    // component: Assets, // old components of assets
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Assets",
  },

  {
    path: "/collectibles_new",
    name: "Collectibles",
    component: Collectibles,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assets New",
  },
  {
    path: "/items/:name",
    name: "Items",
    component: Items,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Items",
  },
  {
    path: "/inventory_new",
    name: "Inventory",
    component: inventory,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assets New",
  },
  {
    path: "/add_item/:propertyId/:roomId",
    name: "Add Item",
    component: ItemMain,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assets New",
  },
  {
    path: "/update_item/:id/:propertyId/:roomId",
    name: "Update Item",
    component: ItemUpdate,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assets New",
  },

  {
    path: "/items",
    name: "Items New",
    component: Items,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assets New",
  },
  // {
  //   path: "/assets_new/:module",
  //   name: "Asset New",
  //   // component: AssetsNew,
  //   component: AllocationSubform,
  //   route: PrivateRoute,
  //   disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
  //   title: "Assets New",
  // },
  {
    path: "/assets_new/attributes/:module",
    name: "List",
    component: AllocationSubform,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/assets_new/attributes/:module/:id",
    name: "List",
    component: AllocationSubform,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/assets_new/attributes/:module/:id/:view",
    name: "List",
    component: AllocationSubform,
    route: PrivateRoute,
    title: "List",
  },
  //airplane properties
  {
    path: "/assets_new/:module",
    name: "Airplane Listing",
    component: AssetListing,
    route: PrivateRoute,
    title: "Airplane Listing",
  },

  {
    path: "/old/assets_new",
    name: "Asset New",
    component: AssetsNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assets New",
  },
  {
    path: "/asset_allocation",
    name: "Asset New",
    component: AssetAllocation,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Asset Allocation",
  },
  {
    path: "/assets_edit/:assetsID",
    name: "Asset Edit",
    component: AssetsNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Assets Edit",
  },
  {
    path: "/assets_view/:assetsID",
    name: "Asset View",
    component: AssetsView,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Assets View",
  },

  {
    path: "/liabilities_credit",
    name: "Liabilities and Credit",
    component: LiabilityDashboard,
    // component: LiabilitiesCredit,  old design component
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Liabilities And Credit",
  },
  // {
  //   path: "/liabilitiesCredit",
  //   name: "Liabilities",
  //   component: LiabilityDashboard,
  //   route: PrivateRoute,
  //   disableRoles: [ROLES.FREE_APP_SUITE],
  //   title: "Liabilities And Credit",
  // },
  // {
  //   path: "/liabilities_credit_new/attributes/:module",
  //   name: "Liabilities and Credit New",
  //   component: LiabilityCreditNew,
  //   route: PrivateRoute,
  //   disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
  //   title: "Liabilities And Credit New",
  // },
  // {
  //   path: "/liabilities_credit_new",
  //   name: "Liabilities and Credit New",
  //   component: AssetAllocationLiabilites,
  //   route: PrivateRoute,
  //   disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
  //   title: "Liabilities And Credit New",
  // },

  {
    path: "/liabilities_credit_new",
    name: "Liabilities and Credit",
    component: AssetAllocationLiabilites,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Liabilities And Credit New",
  },

  {
    path: "/liabilities_credit_new/:module",
    name: "Liabilities and Credit",
    component: LiabilityListing,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Liabilities And Credit New Module",
  },

  {
    path: "/liabilities_credit_new/attributes/:module",
    name: "Liabilities and Credit",
    component: LiabilitySubForm,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/liabilities_credit_new/attributes/:module/:id",
    name: "Liabilities and Credit",
    component: LiabilitySubForm,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/liabilities_credit_new/attributes/:module/:id/:view",
    name: "Liabilities and Credit",
    component: LiabilitySubForm,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/liabilities_credit_edit/:liabilitiesCreditID",
    name: "Liabilities and Credit Edit",
    component: LiabilityCreditNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITofE, ROLES.VIEW_ONLY],
    title: "Liabilities And Credit Edit",
  },
  {
    path: "/liabilities_credit_view/:liabilitiesCreditID",
    name: "Liabilities and Credit View",
    component: LiabilityCreditView,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Liabilities And Credit View",
  },
  {
    path: "/social_security",
    name: "Social Security",
    component: SocialSecurityModule,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Social Security",
  },
  {
    path: "/social_security_new",
    name: "Social Security New",
    component: SocialSecurityNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Social Security New",
  },
  {
    path: "/social_security_edit",
    name: "Social Security Edit",
    component: SocialSecurityNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Social Security Edit",
  },
  {
    path: "/income",
    name: "Income",
    component: IncomeDashboard,
    // component: Income, old income design
    route: PrivateRoute,
    disableRoles: [],
    title: "Income",
  },
  {
    path: "/income_new",
    name: "Income New",
    component: IncomeAllocation,
    route: PrivateRoute,
    disableRoles: [ROLES.VIEW_ONLY],
    title: "Income New",
  },
  {
    path: "/income_new/attributes/:module",
    name: "Income",
    component: IncomeSubForm,
    route: PrivateRoute,
    title: "Income",
  },
  {
    path: "/income_new/attributes/:module/:id",
    name: "Income",
    component: IncomeSubForm,
    route: PrivateRoute,
    title: "Income",
  },
  {
    path: "/income_new/attributes/:module/:id/:view",
    name: "Income",
    component: IncomeSubForm,
    route: PrivateRoute,
    title: "Income",
  },

  {
    path: "/income_edit/:incomeID",
    name: "Income Edit",
    component: IncomeNew,
    route: PrivateRoute,
    disableRoles: [ROLES.VIEW_ONLY],
    title: "Income Edit",
  },
  {
    path: "/income_view/:incomeID",
    name: "Income Edit",
    component: IncomeView,
    route: PrivateRoute,
    disableRoles: [ROLES.VIEW_ONLY],
    title: "Income View",
  },
  {
    path: "/insurance",
    name: "Insurance",
    component: InsuranceDashboard,
    // component: Insurance,  ///  old components
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Insurance",
  },
  {
    path: "/insurance_new",
    name: "Insurance New",
    component: InsuranceAllocation,
    // component: InsuranceNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Insurance New",
  },
  {
    path: "/insurance_new/attributes/:module",
    name: "Insurance",
    component: InsuranceSubForm,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/insurance_new/attributes/:module/:id",
    name: "Insurance",
    component: InsuranceSubForm,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/insurance_new/attributes/:module/:id/:view",
    name: "Insurance",
    component: InsuranceSubForm,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/organizer/insurance",
    name: "Insurance",
    component: InsuranceMainDashboard,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Insurance",
  },
  {
    path: "/organizer/insurance/add",
    name: "Create New Insurance",
    component: InsuranceSelection,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Create New Insurance",
  },

  {
    path: "/organizer/insurance/attributes/:module",
    name: "Insurance",
    component: InsuranceAllocationSubform,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/organizer/insurance/attributes/:module/:id",
    name: "Insurance",
    component: InsuranceAllocationSubform,
    route: PrivateRoute,
    title: "List",
  },
  {
    path: "/organizer/insurance/attributes/:module/:id/:view",
    name: "Insurance",
    component: InsuranceAllocationSubform,
    route: PrivateRoute,
    title: "List",
  },

  {
    path: "/insurance_edit/:insuranceID",
    name: "Insurance Edit",
    component: InsuranceNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Insurance Edit",
  },
  {
    path: "/insurance_view/:insuranceID",
    name: "Insurance View",
    component: InsuranceView,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Insurance View",
  },
  {
    path: "/organizer/important-document",
    name: "Important Documents",
    component: ImportantDocumentMain,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Important Documents",
  },
  {
    path: "/organizer/important-document/:moduleName",
    name: "Important Documents",
    component: ModuleDocuments,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Important Documents",
  },
  {
    path: "/budget",
    name: "Budget",
    component: BudgetMain,
    // component: Budget,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Budget",
  },
  {
    path: "/budget/add/budget",
    name: "Add Budget",
    component: AddBudget,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Add Budget",
  },
  {
    path: "/budget/add/transaction",
    name: "Add Transaction",
    component: AddTransaction,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Add Transaction",
  },
  {
    path: "/budget/add/transaction/rules",
    name: "Transaction Rules",
    component: TransactionRules,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Transaction Rules",
  },
  {
    path: "/budget/transaction/recurring",
    name: "Recurring",
    component: Recurring,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Recurring",
  },
  {
    path: "/budget/transaction/recurring/rules",
    name: "Recurring",
    component: RecurringPattren,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Recurring",
  },
  {
    path: "/budget_account_add",
    name: "Budget Account Add",
    component: BudgetAccountAdd,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Budget Account Add",
  },
  {
    path: "/budget_account_list",
    name: "Budget Accounts Page",
    component: BudgetAccountList,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Budget Accounts Page",
  },
  {
    path: "/budget/create",
    name: "Budget",
    component: BudgetCreate,
    route: PublicRoute,
    disableRoles: [],
    title: "Budget Create",
  },

  {
    path: "/debtPayOff",
    name: "DebtPayOff",
    component: DebtPayOffDashboard,
    route: PublicRoute,
    disableRoles: [],
    title: "DebtPayOff",
  },
  {
    path: "/debt-payoff",
    name: "Debt Payoff",
    component: DebtDashboardMain,
    route: PrivateRoute,
    disableRoles: [],
    title: "Debt Payoff",
  },
  {
    path: "/debt-payoff/strategy",
    name: "Strategy",
    component: DebtStrategy,
    route: PrivateRoute,
    disableRoles: [],
    title: "Strategy",
  },
  {
    path: "/debt-payoff/debt-details/:module/:id",
    name: "Strategy",
    component: DebtsDetails,
    route: PrivateRoute,
    disableRoles: [],
    title: "Strategy",
  },
  {
    path: "/debtDetails",
    name: "DebtDetails",
    component: DebtDetails,
    route: PublicRoute,
    disableRoles: [],
    title: "DebtDetails",
  },
  {
    path: "/strategy",
    name: "Strategy",
    component: Strategy,
    route: PublicRoute,
    disableRoles: [],
    title: "Strategy",
  },
  {
    path: "/payOffPlan",
    name: "payOffPlan",
    component: PayOffPlans,
    route: PublicRoute,
    disableRoles: [],
    title: "payOffPlan",
  },

  {
    path: "/debt/create",
    name: "Debt",
    component: DebtCreate,
    route: PublicRoute,
    disableRoles: [],
    title: "Debt Create",
  },
  {
    path: "/planner/social-security",
    name: "Social Security",
    component: SocialSecurityMain,
    route: PrivateRoute,
    disableRoles: [],
    title: "Social Security",
  },
  {
    path: "/planner/social-security/fra",
    name: "Social Security",
    component: SocialSecurityFRA,
    route: PrivateRoute,
    disableRoles: [],
    title: "Social Security",
  },
   {
    path: "/planner/social-security/early-vs-70",
    name: "Social Security",
    component: SocialSecurityEarly70,
    route: PrivateRoute,
    disableRoles: [],
    title: "Social Security",
  },
   {
    path: "/planner/social-security/spousal-early-vs-FRA",
    name: "Social Security",
    component: SocialSecurityEarlyvsFRA,
    route: PrivateRoute,
    disableRoles: [],
    title: "Social Security",
  },
   {
    path: "/planner/social-security/compare-ages",
    name: "Social Security",
    component: CompareTwoAges,
    route: PrivateRoute,
    disableRoles: [],
    title: "Social Security",
  },
  {
    path: "/social/create",
    name: "Social",
    component: SocialSecurityCreate,
    route: PublicRoute,
    disableRoles: [],
    title: "Social Create",
  },
  {
    path: "/social/",
    name: "Social",
    component: SocialSecurityDashboard,
    route: PublicRoute,
    disableRoles: [],
    title: "Social Dashboard",
  },
  //goals
  // { path: '/goals', name: 'Goals', component: Goals, route: PrivateRoute, disableRoles: [ROLES.FREE_APP_SUITE], title: 'Goals'},
  {
    path: "/goals",
    name: "Goals",
    // component: GoalsList, // old component
    component: GoalsDashboard,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Goals List",
  },
  {
    path: "/goals_add",
    name: "Goals New",
    // component: Goals,  // old compoment
    component: SelectGoal,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Goals",
    exact: true,
  },
  {
    path: "/goals_add/attributes/:module",
    name: "Goals",
    component: GoalAllocationSubform,
    route: PrivateRoute,
    title: "Goals",
  },
  {
    path: "/goals_add/attributes/:module/:id",
    name: "Goals",
    component: GoalAllocationSubform,
    route: PrivateRoute,
    title: "Goals",
  },
  {
    path: "/goals_add/attributes/:module/:id/:view",
    name: "Goals",
    component: GoalAllocationSubform,
    route: PrivateRoute,
    title: "Goals",
  },
  {
    path: "/goals_new/:id",
    name: "Goals New",
    component: GoalsNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "GoalsNew",
  },

  //schedules
  {
    path: "/schedules",
    name: "Schedules",
    component: Schedules,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Schedules",
  },
  {
    path: "/asset_distribution",
    name: "Asset Distribution",
    component: AssetDistribution,
    route: PrivateRoute,
    disableRoles: [],
    title: "Asset Distribution",
  },
  {
    path: "/asset_distribution_rmd",
    name: "Asset Distribution RMD",
    component: AssetDistributionRMD,
    route: PrivateRoute,
    disableRoles: [],
    title: "Asset Distribution RMD",
  },
  {
    path: "/amortization_report",
    name: "Amortization Report",
    component: AmortizationReport,
    route: PrivateRoute,
    disableRoles: [],
    title: "Amortization Report",
  },
  {
    path: "/amortization_schedule",
    name: "Amortization Schedule",
    component: AmortizationSchedule,
    route: PrivateRoute,
    disableRoles: [],
    title: "Amortization Schedule",
  },
  {
    path: "/debt_payoff_amount",
    name: "Debt Pay off Amount",
    component: DebtPayoffAmount,
    route: PrivateRoute,
    disableRoles: [],
    title: "Debt Pay off Amount",
  },
  {
    path: "/payoff_debt_free_date",
    name: "Payoff Debt Free Date",
    component: PayoffDebtFreeDate,
    route: PrivateRoute,
    disableRoles: [],
    title: "Payoff Debt Free Date",
  },
  {
    path: "/portfolio_performance_of_30_years",
    name: "Portfolio Performance",
    component: PortfolioPerformance,
    route: PrivateRoute,
    disableRoles: [],
    title: "Portfolio Performance",
  },

  //client info
  {
    path: "/client_info",
    name: "Client Info",
    component: ClientInfo,
    route: PrivateRoute,
    disableRoles: [],
    title: "Client Info",
  },
  {
    path: "/clients/plans", //new='/clients/plans' old='/clients_plans'
    name: "Clients and Plans",
    component: ClientsPlans,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE],
    title: "Clients and Plans",
  },
  {
    path: "/chats",
    name: "Chats",
    component: ChatSystemMain,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE],
    title: "Chats",
  },
  {
    path: "/client/plan", //new='/clients/plans' old='/clients_plans'
    name: "Client Contacts",
    component: ClientPlan,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE],
    title: "Client Contacts",
  },
  {
    path: "/my_information",
    name: "My Information",
    component: MyInformation,
    route: PrivateRoute,
    disableRoles: [
      ROLES.SUPER_ADMIN,
      ROLES.COR_SUPER_ADMIN,
      ROLES.SUPERVISOR_ADMIN,
      ROLES.PROFESSIONAL,
      ROLES.FREE_APP_SUITE,
      ROLES.VIEW_ONLY,
    ],
    title: "My Information",
  },
  {
    path: "/edit_information",
    name: "Edit Information",
    component: EditInformation,
    route: PrivateRoute,
    disableRoles: [
      ROLES.SUPER_ADMIN,
      ROLES.COR_SUPER_ADMIN,
      ROLES.SUPERVISOR_ADMIN,
      ROLES.PROFESSIONAL,
      ROLES.FREE_APP_SUITE,
      ROLES.VIEW_ONLY,
    ],
    title: "Edit Information",
  },
  {
    //new
    path: "/clients/plans/compare",
    name: "Compare Plans",
    component: ComparePlans,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Compare Plans",
  },
  {
    //new
    path: "/clients/:id/plans",
    name: "Client Detail",
    component: ClientDetail,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Client Information",
  },
  {
    //new
    path: "/clients/:id/edit/plans",
    name: "Client Edit Detail",
    component: ClientEditDetail,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Client Edit Detail",
  },
  {
    path: "/client_new",
    name: "Client New",
    component: ClientNew,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Client New",
  },
  {
    path: "/clients/plans/create",
    name: "Client Plan New",
    component: ClientPlanNew,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Client Plan New",
  },
  {
    path: "/client_plan_edit/:planID",
    name: "Client Plan Edit",
    component: ClientPlanNew,
    route: PrivateRoute,
    disableRoles: [ROLES.CONSUMER, ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Client Plan Edit",
  },
  {
    path: "/tax_inflation",
    name: "Tax and Inflation",
    component: TaxAndInflation,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Tax and Inflation",
  },
  {
    path: "/tax_inflation_new",
    name: "Tax and Inflation New",
    component: TaxInflationNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Tax and Inflation New",
  },
  {
    path: "/tax_inflation_edit/:taxInflationID",
    name: "Tax and Inflation Edit",
    component: TaxInflationMain,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Tax and Inflation Edit",
  },
  {
    path: "/client_contacts",
    name: "Client Contacts",
    component: ClientContacts,
    route: PrivateRoute,
    disableRoles: [],
    title: "Client Contacts",
  },
  {
    path: "/client_contact_new",
    name: "Client Contact New",
    component: ClientContactNew,
    route: PrivateRoute,
    disableRoles: [ROLES.VIEW_ONLY],
    title: "Client Contact New",
  },
  {
    path: "/client_contact_edit/:clientContactID",
    name: "Client Contact Edit",
    component: ClientContactNew,
    route: PrivateRoute,
    disableRoles: [ROLES.VIEW_ONLY],
    title: "Client Contact Edit",
  },
  {
    path: "/client_contact_view/:clientContactID",
    name: "Client Contact View",
    component: ClientContactView,
    route: PrivateRoute,
    disableRoles: [ROLES.VIEW_ONLY],
    title: "Client Contact View",
  },
  {
    path: "/custom_components",
    name: "Custom Components",
    component: CustomComponents,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Custom Components",
  },

  {
    path: "/rates_of_return",
    name: "Rates of Return",
    component: RatesOfReturn,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Rates of Return",
  },
  {
    path: "/rates_of_return_new",
    name: "Rates of Return New",
    component: ReturnRatesNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Rates of Return New",
  },
  {
    path: "/rates_of_return_edit/:ratesOfReturnID",
    name: "Rates of Return Edit",
    component: RatesOfReturnMain,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Rates of Return Edit",
  },

  // Reports
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Reports",
  },
  {
    path: "/reports/budget",
    name: "Budget Report",
    component: BudgetReportDashboard,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Budget Report",
  },
  {
    path: "/reports/budgetDetails",
    name: "Budget Details",
    component: BudgetDetailReports,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Budget Details",
  },
  {
    path: "/reports/budgetDetails/allReports",
    name: "Budget Details",
    component: AllReportsMain,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Budget Details",
  },
  {
    path: "/report_asset",
    name: "Reports Asset",
    component: ReportAsset,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Report Asset",
  },
  {
    path: "/add_asset",
    name: "Asset Add",
    component: AddAsset,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Add Asset",
  },
  {
    path: "/report_all_insurance_products",
    name: "Report - All Insurance Products",
    component: AllInsuranceProducts,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Report All Insurance Products",
  },
  {
    path: "/report_prefessional_team",
    name: "Report - Prefessional Team",
    component: PrefessionalTeam,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Report Prefessional Team",
  },
  {
    path: "/report_general_information",
    name: "General Information Report",
    component: GeneralInformation,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "General Information Report",
  },
  {
    path: "/income_report",
    name: "Income Report",
    component: IncomeReport,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Income Report",
  },
  {
    path: "/goals_report",
    name: "Goals Report",
    component: GoalsReport,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Goals Report",
  },
  {
    path: "/insurance_report",
    name: "Insurance Report",
    component: InsuranceReport,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Insurance Report",
  },
  {
    path: "/liabilities_credit_report",
    name: "Liabilities and Credit Report",
    component: LiabilitiesCreditReport,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Liabilities and Credit Report",
  },
  {
    path: "/liquidity_report",
    name: "Liquidity Report",
    component: LiquidityReport,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Liquidity Report",
  },
  {
    path: "/report_monthly_savings",
    name: "Report Monthly Savings",
    component: MonthlySavings,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Report Monthly Savings",
  },
  {
    path: "/social_security_report",
    name: "Social Security Report",
    component: SocialSecurity,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Social Security Report",
  },
  {
    path: "/starting_a_business_report",
    name: "Starting a Business Report",
    component: StartingBusinessReport,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "Starting a Business Report",
  },
  {
    path: "/asset_item_report",
    name: "Asset Items Report",
    component: AssetsItemReport,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "All Items Report",
  },
  {
    path: "/income_and_taxes",
    name: "Income and Taxes",
    component: IncomeAndTaxes,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE],
    title: "All Items Report",
  },
  {
    path: "/insurance_payout",
    name: "Insurance Payout",
    component: InsurancePayout,
    route: PrivateRoute,
    disableRoles: [],
    title: "All Items Report",
  },
  {
    path: "/budget_and_goals",
    name: "Budget and Goals",
    component: BudgetAndGoals,
    route: PrivateRoute,
    disableRoles: [],
    title: "All Items Report",
  },
  {
    path: "/liabilities_items_report",
    name: "Liabilities",
    component: Liabilities,
    route: PrivateRoute,
    disableRoles: [],
    title: "All Items Report",
  },
  {
    path: "/budget_report",
    name: "Budget Report",
    component: BudgetReport,
    route: PrivateRoute,
    disableRoles: [],
    title: "Budget Report",
  },
  {
    path: "/budget_detailed",
    name: "Budget Detailed",
    component: BudgetDetailed,
    route: PrivateRoute,
    disableRoles: [],
    title: "Budget Detailed",
  },
  {
    path: "/net_worth_report",
    name: "Net Worth Report",
    component: NetWorthReport,
    route: PrivateRoute,
    disableRoles: [],
    title: "Net Worth Report",
  },

  // Worst Case Scenarios
  {
    path: "/executor_trustee_start",
    name: "Executor/Trustee Start Here",
    component: ExecutorTrusteeStart,
    route: PrivateRoute,
    disableRoles: [],
    title: "Executor/Trustee Start Here",
  },
  {
    path: "/worst_case_scenarios",
    name: "Worst Case Scenarios",
    component: WorstCaseScenarios,
    route: PrivateRoute,
    disableRoles: [],
    title: "Worst Case Scenarios",
  },
  {
    path: "/check_list",
    name: "Check List Report",
    component: CheckList,
    route: PrivateRoute,
    disableRoles: [],
    title: "Check List Report",
  },
  {
    path: "/add_check_list",
    name: "Add Check List",
    component: AddCheckList,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Check List",
  },
  {
    path: "/contact_list",
    name: "Contact List",
    component: ContactList,
    route: PrivateRoute,
    disableRoles: [],
    title: "Contact List Report",
  },
  {
    path: "/add_contact_list",
    name: "Add Contact List",
    component: AddContactList,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Contact List",
  },
  {
    path: "/important_documents",
    name: "All Important Documents",
    component: ImportantDocuments,
    route: PrivateRoute,
    disableRoles: [],
    title: "All Important Documents",
  },
  {
    path: "/add_important_documents",
    name: "Add Important Document",
    component: AddImportantDocuments,
    route: PrivateRoute,
    disableRoles: [],
    title: "All Important Documents",
  },
  {
    path: "/personal_instructions",
    name: "All Personal Instructions",
    component: PersonalInstructions,
    route: PrivateRoute,
    disableRoles: [],
    title: "All Personal Instructions",
  },
  {
    path: "/add_personal_instructions",
    name: "Add Personal Instruction",
    component: AddPersonalInstructions,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Personal Instruction",
  },
  {
    path: "/list_of_large_bills",
    name: "List of Large Bills",
    component: ListOfLargeBills,
    route: PrivateRoute,
    disableRoles: [],
    title: "List of Large Bills",
  },
  {
    path: "/add_list_of_large_bills",
    name: "Add List of Large Bill",
    component: AddListOfLargeBill,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add List of Large Bill",
  },
  {
    path: "/litigation_lists",
    name: "Litigation Lists",
    component: LitigationLists,
    route: PrivateRoute,
    disableRoles: [],
    title: "Litigation Lists",
  },
  {
    path: "/add_litigation_lists",
    name: "Add Litigation List",
    component: AddLitigationList,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Litigation List",
  },
  {
    path: "/location_of_personal_items",
    name: "Location of personal items",
    component: LocationOfPersonalItems,
    route: PrivateRoute,
    disableRoles: [],
    title: "Location of personal items",
  },
  {
    path: "/add_location_of_personal_item",
    name: "Add Litigation List",
    component: AddLocationOfPersonalItem,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Litigation List",
  },
  {
    path: "/list_of_passwords",
    name: "List of passwords Report",
    component: ListOfPasswords,
    route: PrivateRoute,
    disableRoles: [],
    title: "List of passwords Report",
  },
  {
    path: "/add_list_of_passwords",
    name: "Add List of passwords",
    component: AddListOfPasswords,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add List of passwords",
  },
  {
    path: "/prepaid_burial_expenses",
    name: "Prepaid Burial Expenses Report",
    component: PrepaidBurialExpenses,
    route: PrivateRoute,
    disableRoles: [],
    title: "Prepaid Burial Expenses Report",
  },
  {
    path: "/add_prepaid_burial_expenses",
    name: "Add Prepaid Burial Expenses",
    component: AddPrepaidBurialExpenses,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Prepaid Burial Expenses",
  },
  {
    path: "/progress_statuses",
    name: "All Progress Statuses",
    component: ProgressStatuses,
    route: PrivateRoute,
    disableRoles: [],
    title: "All Progress Statuses",
  },
  {
    path: "/add_progress_statuses",
    name: "Progress Statuses",
    component: AddProgressStatuses,
    route: PrivateRoute,
    disableRoles: [],
    title: "Progress Statuses",
  },
  {
    path: "/audio_video_message",
    name: "Audio/Video Message",
    component: AudioVideoMessage,
    route: PrivateRoute,
    disableRoles: [],
    title: "Audio/Video Message",
  },
  {
    path: "/add_audio_video_message",
    name: "Add Audio/Video Message",
    component: AddAudioVideoMessage,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Audio/Video Message",
  },
  {
    path: "/emails_to_send",
    name: "Emails to Send",
    component: EmailsToSend,
    route: PrivateRoute,
    disableRoles: [],
    title: "Emails to Send",
  },
  {
    path: "/add_emails_to_send",
    name: "Add Emails to Send",
    component: AddEmailsToSend,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Emails to Send",
  },

  // View Worst Case Scenarios
  {
    path: "/worst_case_scenarios_view",
    name: "View Worst Case Scenarios",
    component: WorstCaseScenariosView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "View Worst Case Scenarios",
  },
  {
    path: "/check_list_view",
    name: "View Check List Report",
    component: CheckListView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Check List Report",
  },
  {
    path: "/contact_list_view",
    name: "View Contact List",
    component: ContactListView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Contact List Report",
  },
  {
    path: "/important_documents_view",
    name: "View All Important Documents",
    component: ImportantDocumentsView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "All Important Documents",
  },
  {
    path: "/personal_instructions_view",
    name: "View All Personal Instructions",
    component: PersonalInstructionsView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "All Personal Instructions",
  },
  {
    path: "/list_of_large_bills_view",
    name: "View List of Large Bills",
    component: ListOfLargeBillsView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "List of Large Bills",
  },
  {
    path: "/litigation_lists_view",
    name: "View Litigation Lists",
    component: LitigationListsView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Litigation Lists",
  },
  {
    path: "/location_of_personal_items_view",
    name: "View Location of personal items",
    component: LocationOfPersonalItemsView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Location of personal items",
  },
  {
    path: "/list_of_passwords_view",
    name: "View List of passwords Report",
    component: ListOfPasswordsView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "List of passwords Report",
  },
  {
    path: "/prepaid_burial_expenses_view",
    name: "View Prepaid Burial Expenses Report",
    component: PrepaidBurialExpensesView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Prepaid Burial Expenses Report",
  },
  {
    path: "/progress_statuses_view",
    name: "View All Progress Statuses",
    component: ProgressStatusesView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "All Progress Statuses",
  },
  {
    path: "/audio_video_message_view",
    name: "View Audio/Video Message",
    component: AudioVideoMessageView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Audio/Video Message",
  },
  {
    path: "/emails_to_send_view",
    name: "View Emails to Send",
    component: EmailsToSendView,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Emails to Send",
  },
  {
    path: "/summary",
    name: "Summary",
    component: Summary,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "Summary",
  },
  {
    path: "/asset_planet_message",
    name: "AssetPlanetMessage",
    component: AssetPlanetMessage,
    route: PrivateRoute,
    roles: ["Admin"],
    title: "AssetPlanetMessage",
  },

  //Planner
  {
    path: "/planner",
    name: "Planner",
    component: Planner,
    route: PrivateRoute,
    disableRoles: [],
    title: "Planner",
  },

  //FAQ's Route
  {
    path: "/faq",
    name: "Faq",
    component: Faq,
    route: PublicRoute,
    disableRoles: [],
    title: "Faq",
  },

  // Inventory and Collection Routes
  {
    path: "/inventory",
    name: "Inventory",
    component: Inventory,
    route: PrivateRoute,
    disableRoles: [],
    title: "Inventory",
  },
  {
    path: "/collection/:id",
    name: "Collection",
    component: Collection,
    route: PrivateRoute,
    disableRoles: [],
    title: "Collection",
  },

  //Property Detail
  {
    path: "/property-detail/:id",
    name: "Property Detail",
    component: Detail,
    route: PrivateRoute,
    disableRoles: [],
    title: "Property Detail",
  },

  //Room Detail
  {
    path: "/room-detail/:id/:propertyId",
    name: "Room Detail",
    component: Detail,
    route: PrivateRoute,
    disableRoles: [],
    title: "Room Detail",
  },

  //Item Detail
  {
    path: "/item-detail/:id",
    name: "Item Detail",
    component: Detail,
    route: PrivateRoute,
    disableRoles: [],
    title: "Item Detail",
  },
  //Protector
  {
    path: "/protector",
    name: "Protector",
    component: Protector,
    route: PrivateRoute,
    disableRoles: [],
    title: "Protector",
  },
  {
    path: "/divorce",
    name: "Divorce",
    component: Divorce,
    route: PrivateRoute,
    disableRoles: [],
    title: "Divorce",
  },
  {
    path: "/divorce/create",
    name: "DivorceCreate",
    component: DivorceCreate,
    route: PrivateRoute,
    disableRoles: [],
    title: "Divorce Create",
  },
  {
    path: "/death",
    name: "Death",
    component: Death,
    route: PrivateRoute,
    disableRoles: [],
    title: "Death",
  },
  {
    path: "/death/create",
    name: "DivorceCreate",
    component: DeathCreate,
    route: PrivateRoute,
    disableRoles: [],
    title: "Death Create",
  },
  {
    path: "/disaster",
    name: "Disaster",
    component: Disaster,
    route: PublicRoute,
    disableRoles: [],
    title: "Disaster",
  },
  {
    path: "/disaster/create",
    name: "Disaster",
    component: DisasterCreate,
    route: PublicRoute,
    disableRoles: [],
    title: "Disaster Create",
  },
  {
    path: "/divorce",
    name: "Divorce",
    component: Divorce,
    route: PublicRoute,
    disableRoles: [],
    title: "Divorce",
  },
  {
    path: "/divorce/create",
    name: "Divorce",
    component: DivorceCreate,
    route: PublicRoute,
    disableRoles: [],
    title: "Divorce Create",
  },
  {
    path: "/disability",
    name: "Disability",
    component: Disability,
    route: PublicRoute,
    disableRoles: [],
    title: "Disability",
  },
  {
    path: "/disability/create",
    name: "Disability",
    component: DisabilityCreate,
    route: PublicRoute,
    disableRoles: [],
    title: "Disability Create",
  },

  //TEST MODS
  {
    path: "/friends-family",
    name: "Test Mods",
    component: TestMods,
    route: PrivateRoute,
    disableRoles: [],
    title: "Test Mods",
  },
  {
    path: "/friends-family-one-time",
    name: "Friends and Family One Time Payment",
    component: OneTimePayments,
    route: PrivateRoute,
    disableRoles: [],
    title: "Friends and Family One Time Payment",
  },
  {
    path: "/friends-family-multiple",
    name: "Friends and Family Multiple Payments",
    component: MultiplePayments,
    route: PrivateRoute,
    disableRoles: [],
    title: "Friends and Family Multiple Payments",
  },
  {
    path: "/question-add-another",
    name: "Friends and Family Multiple Payments",
    component: QuestionAddAnotherSubForm,
    route: PrivateRoute,
    disableRoles: [],
    title: "Friends and Family Multiple Payments",
  },
  {
    path: "/assign-savings-to-goal",
    name: "Assign Savings To Goal",
    component: AssignSavingsToGoalSubForm,
    route: PrivateRoute,
    disableRoles: [],
    title: "Assign Savings To Goal",
  },

  {
    path: "/question-add-another-cont-save",
    name: "Add Another Contribution or Savings?",
    component: QuestionAddAnotherContSavings,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Another Contribution or Savings?",
  },

  {
    path: "/student-loan-details",
    name: "Student Loan Details",
    component: StudentLoanDetails,
    route: PrivateRoute,
    disableRoles: [],
    title: "Student Loan Details",
  },
  {
    path: "/question-add-another-student-loan",
    name: "Add Another Student Loan?",
    component: QuestionAddAnotherStudentLoan,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Another Student Loan?",
  },

  {
    path: "/scholorships_grants",
    name: "Scholarships and Grants",
    component: ScholarshipsGrantsDetails,
    route: PrivateRoute,
    disableRoles: [],
    title: "Scholarships and Grants",
  },

  {
    path: "/question-add-another-scholarship-grant",
    name: "Add Another Scholarship  Grant?",
    component: QuestionAddAnotherScholarshipGrant,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add AnotherScholarships  Grant?",
  },

  {
    path: "/question-add-another-personal-loan",
    name: "Add Another Personal Loan?",
    component: QuestionAddAnotherPersonalLoan,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Another Personal Loan?",
  },
  {
    path: "/personal_loan",
    name: "Loan Details",
    component: PersonalLoanHeloc,
    route: PrivateRoute,
    disableRoles: [],
    title: "Loan Details",
  },

  {
    path: "/parent_plus_loan",
    name: "Parent Plus Loan",
    component: ParentPLUSLoan,
    route: PrivateRoute,
    disableRoles: [],
    title: "Parent Plus Loan",
  },

  {
    path: "/personal_loan_heloc",
    name: "Personal Loan  HELOC",
    component: PersonalLoanHelocDetails,
    route: PrivateRoute,
    disableRoles: [],
    title: "Personal Loan  HELOC",
  },

  {
    path: "/work-study",
    name: "Work Study",
    component: WorkStudyDetails,
    route: PrivateRoute,
    disableRoles: [],
    title: "Work Study",
  },
  {
    path: "/question-add-another-work-study",
    name: "Add Another Work Study?",
    component: QuestionAddAnotherWorkStudy,
    route: PrivateRoute,
    disableRoles: [],
    title: "Add Another Work Study?",
  },
  {
    path: "/private-education-details",
    name: "Private Education Details",
    component: PrivateEducationDetails,
    route: PrivateRoute,
    disableRoles: [],
    title: "Private Education Details",
  },
  {
    path: "/private-education-k12-details",
    name: "Private Education K12 Details",
    component: PrivateEducationK12Details,
    route: PrivateRoute,
    disableRoles: [],
    title: "Private Education K12 Details",
  },

  {
    path: "/room-board-misc",
    name: "Room, Board, Misc",
    component: RoomBoardMiscDetails,
    route: PrivateRoute,
    disableRoles: [],
    title: "Room, Board, Misc",
  },

  {
    path: "/tuition-costs",
    name: "Tuition Costs",
    component: TuitionCosts,
    route: PrivateRoute,
    disableRoles: [],
    title: "Tuition Costs",
  },

  ////// PRIVATE EDUCATION
  {
    path: "/private-education",
    name: "Private Education List",
    component: PrivateEducationList,
    route: PrivateRoute,
    disableRoles: [],
    title: "Private Education List",
  },
  {
    path: "/private-education-dash",
    name: "Private Education Dashboard",
    component: PrivateEducationDash,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "Private Education Dashboard",
    exact: true,
  },

  {
    path: "/private-education-new/:id",
    name: "Private Education New",
    component: PrivateEducationNew,
    route: PrivateRoute,
    disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY],
    title: "PrivateEducationNew",
  },

  ////////  { path: '/goals_new/:id', name: 'Goals New', component: GoalsNew, route: PrivateRoute, disableRoles: [ROLES.FREE_APP_SUITE, ROLES.VIEW_ONLY], title: 'GoalsNew'},

  // Charts
  {
    path: "/charts",
    name: "Charts",
    component: Charts,
    route: PrivateRoute,
    disableRoles: [],
    title: "Charts",
  },

  {
    path: "/",
    exact: true,
    // component: () => <Redirect to="/dashboard" />,
    component: () => <Redirect to="/login" />,
    route: PrivateRoute,
  },
  {
    path: "/*",
    name: "Page Not Found",
    component: PageNotFound,
    route: PublicRoute,
  },
];

export { routes, PrivateRoute };
